import { observable, action } from 'mobx'
import { StoreExt } from 'util/reactExt'
import storage from 'storejs'

export class SearchStore extends StoreExt {
  @observable searchKeyWords: string = ''
  @observable searchType: string = ''
  @observable searchSort: number = 0
  @observable
  searchResult = {
    article: {
      data: [],
      total: 0,
    },
    course: {
      data: [],
      total: 0,
    },
    topic: {
      data: [],
      total: 0,
    },
    courseware: {
      data: [],
      total: 0,
    },
  }

  @action
  setSearchKeyWords = newWords => {
    storage.set('searchKeyWords', newWords)
    this.searchKeyWords = newWords || '汪总'
  }

  @action
  querySearchResult = async (pageindex, pagesize) => {
    const params = {
      key_word: this.searchKeyWords,
      pageindex,
      pagesize,
      sort: this.searchSort,
      // type: '',
    }

    // if (this.searchType) {
    //   params.type = this.searchType
    // }

    const res = await this.api.search.search(params)
    if (res) {
      this.setSearchResult(res)
    }
  }

  @action
  setSearchResult = result => {
    this.searchResult = result
  }
}

export default new SearchStore()
